<template>
  <div>
    <b-row align-v="center" align-h="center" style="height: 450px;">
      <b-col cols="10" md="6" lg="3" class="back-panel-login-as">
        <img src="https://www.allseasons.tur.ar/ws/e-booking/images/logo.png" class="mx-auto d-block" />
        <v-form @submit.prevent="getLogin" id="formLogin">
          <v-container>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="Usuario"
                  solo
                  v-validate="'min:3|required'"
                  name="usuario"
                  data-vv-validate-on="blur"
                  v-model.trim="form.username"
                  :error="errors.has('usuario')"
                  :error-messages="errors.first('usuario')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model.trim="form.password"
                  label="Contraseña"
                  solo
                  type="password"
                  v-validate="'min:3|required'"
                  name="password"
                  :error="errors.has('password')"
                  :error-messages="errors.first('password')"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-btn color="info" @click="registrarse" block>Registrarse</v-btn>
              </v-flex>
              <v-flex>
                <v-btn type="submit" color="info" class="float-right" block data-cy="submitLogin">Entrar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </b-col>
      <!--
      <b-col cols="10" class="text-center">
        <v-btn
          class="title"
          depressed 
          large
          small
          color="primary"
          @click="
            _$goToUrl(
              'https://www.allseasons.tur.ar/tarifarios/brasil_index.php'
            )
          "
          >Ir a versión anterior</v-btn
        >
      </b-col>
      -->
    </b-row>
  </div>
</template>
<style scoped>
.back-panel-login-as {
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 7px;
  padding: 10px;
}
.padd {
}
</style>
<script>
// @ is an alias to /src

export default {
  name: "login",
  components: {},
  mounted() {},
  created() {},
  methods: {
    getLogin() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doLogin()
        }
      })
    },
    async doLogin() {
      this.showError = false
      this.mensajeError = null
      var rs = await this.$passporthandler.auth(this.form)
      if (rs.status != 200) {
        this.showError = true
        this.mensajeError = rs.status + " " + rs.detalle
        this.$toasted.error(this.mensajeError, {
          theme: "toasted-primary",
          position: "top-right",
          duration: 3000
        })
        return
      }
      this.$passporthandler.guadarCryted(
        JSON.stringify({
          username: this.form.username,
          password: this.form.password
        }),
        "_"
      )
      await this.$store.dispatch("app/guardarUsuario", this.$passporthandler.getDatosUsuarios())
      this._$goToInicio()
    },
    init() {
      this.setApp()
    },
    setApp() {
      this.$store.dispatch("app/saveApp", this.$route.meta.app)
    },
    registrarse() {
      window.location.href = "https://www.allseasons.tur.ar/tarifarios/hoteleriaOL/registrar.php"
    }
  },
  data() {
    return {
      showError: false,
      mensajeError: null,
      form: {
        username: null,
        password: null,
        client_id: process.env.VUE_APP_CLIENTE_ID,
        client_secret: process.env.VUE_APP_CLIENT_SECRET,
        grantType: "password"
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init()
    })
  }
}
</script>
